import axios from "axios";
import { Toast as showToast } from "core/components/global/toast/toast";
import { fetchBaseUrl } from "core/utils/common";


const baseURL = fetchBaseUrl({});

export async function getUserThemePreference(token: string) {
  try {
    // If token is empty or invalid, return default theme without making the API call
    if (!token || token === "") {
      return "darkTheme";
    }
    
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/api/theme-preference`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (response.status < 300) {
      return response.data?.themePreference || "darkTheme";
    } else {
      return "darkTheme";
    }
  } catch (error) {
    // Silently handle error and return default
    return "darkTheme";
  }
}

export async function updateUserThemePreference(
  token: string,
  theme: "lightTheme" | "darkTheme"
) {
  try {
    // If token is empty or invalid, don't make the API call
    if (!token || token === "") {
      return false;
    }
    
    const response = await axios.request({
      method: "PUT",
      url: `${baseURL}/api/theme-preference`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      data: {
        themePreference: theme,
      },
    });

    return response.status < 300;
  } catch (error) {
    // Silently handle error
    return false;
  }
}
